import { IconFormNames, NewSmartList, SmartList } from '@griply/types';

import { DocumentSnapshot } from '../types/firestore';
import { stripUndefined } from '../utils/strip-undefined';
import { coerceFilterDocument } from './filter-document';
import { firebaseObjectTimestampToDate } from './firebase-timestamp-to-date';

const coerceIcon = (value: unknown): IconFormNames | undefined =>
  Object.values(IconFormNames).includes(value as IconFormNames)
    ? (value as IconFormNames)
    : undefined;

export const smartListConverter = {
  fromFirestore: (snapshot: DocumentSnapshot): SmartList => {
    const data = firebaseObjectTimestampToDate(snapshot.data()) as Record<
      string,
      unknown
    >;
    data.id = snapshot.id;
    // Stripped: consumers spread the converted smart list back into Firestore writes.
    return stripUndefined({
      ...data,
      filterDocument: coerceFilterDocument(data.filterDocument) ?? {},
      icon: coerceIcon(data.icon),
    }) as SmartList;
  },
  toFirestore: (smartList: SmartList) => smartList,
};

export const newSmartListConverter = (smartList: NewSmartList) => ({
  ...smartList,
  createdAt: new Date(),
});
